import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {HttpClient, HttpHeaders} from '@angular/common/http';
import {environment} from '../../../environments/environment';
import {Order} from '../../classes/Order';
import {PaymentService} from '../../services/payment.service';
import {BookingOption} from 'src/app/enums/BookingOption';
import {CouponType} from '../../enums/CouponType';
import {LanguageService} from '../../services/language.service';
import {OrderService} from '../../services/order.service';

const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'}),
};

@Component({
  selector: 'app-book-confirm',
  styleUrls: ['./book-confirm.component.scss'],
  templateUrl: './book-confirm.component.html',
})
export class BookConfirmComponent implements OnInit {

  public orderId: number;
  public order: Order;
  public bookingBadgeClass: string;
  public paymentBadgeClass: string;
  public isWorkplacesAware = false;
  public errorMessage: string;
  public isError = false;

  constructor(private httpClient: HttpClient,
              private router: Router,
              private activatedRoute: ActivatedRoute,
              private paymentService: PaymentService,
              private orderService: OrderService,
              public languageService: LanguageService) {

    this.orderId = this.activatedRoute.snapshot.params.orderId;
  }

  ngOnInit(): void {
    this.httpClient.get(`${environment.backendApiUrl}/v1/orders/` + this.orderId, httpOptions).subscribe(
      (response: Order) => {
        this.order = response;
        switch (this.order.status) {
          case 'PENDING': {
            this.bookingBadgeClass = 'badge-light';
            break;
          }
          case 'READY': {
            this.bookingBadgeClass = 'badge-info';
            break;
          }
          case 'STARTED': {
            this.bookingBadgeClass = 'badge-success';
            break;
          }
          case 'FINISHED': {
            this.bookingBadgeClass = 'badge-primary';
            break;
          }
          case 'CANCELLED': {
            this.bookingBadgeClass = 'badge-danger';
            break;
          }
        }

        switch (this.order.transaction.status) {
          case 'PAID': {
            this.paymentBadgeClass = 'badge-success';
            break;
          }
          case 'UNPAID': {
            this.paymentBadgeClass = 'badge-danger';
            break;
          }
        }
        this.isWorkplacesAware = this.order.bookingOption === BookingOption.ONE_SEAT_2HOURS
            || this.order.bookingOption === BookingOption.ONE_SEAT_FULL_DAY
            || this.order.bookingOption === BookingOption.ONE_SEAT_WEEK
            || this.order.bookingOption === BookingOption.ONE_SEAT_MONTH;
      });
  }

  public async checkout(order: Order): Promise<void> {
    return this.paymentService.orderYaadCheckout(order);
  }

  public discountValue(): string {
    if (this.order.coupon) {
      const coupon = this.order.coupon;
      if (CouponType.PERCENT === coupon.type) {
        return coupon.value + '%';
      }
      if (CouponType.AMOUNT === coupon.type) {
        return coupon.value + '₪';
      }
    }
    return '-';
  }

  cancel(order: Order): void {
    this.orderService.cancelOrder(order.id).subscribe({
      next: (response) => {
        this.router.navigate(['/']).then();
      },
      error: (error) => {
        console.log('error');
        this.isError = true;
        this.errorMessage = error.error.message;
      }
    });
  }
}
